export default {
  pendingLabel: 'Pendente',
  openedLabel: 'Aberto',
  holdingLabel: 'Em Espera',
  repliedLabel: 'Respondido',
  closedLabel: 'Fechado',
  ignoredLabel: 'Ignorado',
};
